export const getParameterQuery = parameter => {
  const urlSearch = new URLSearchParams(window.location.search);
  return urlSearch.get(parameter);
};

export const getPrivatePageUrl = mfePreferences => mfePreferences?.paths?.myPrinters;
